import { lazyLoad } from 'utils/loadable';

export const OrderPreferencesGridLoadable = lazyLoad(
  () => import('./OrderPreferences'),
  module => module.OrderPreferences,
);
